export default {
  namespaced: true,

  state: {
    form: null,
  },

  getters: {
    current(state, getters, rootState, rootGetters) {
      return rootGetters['builder/data'].properties;
    },

    validate(state, getters, rootState, rootGetters) {
      return () => {
        if (!rootGetters['builder/property/enabled']()) {
          return Promise.resolve(true);
        }

        if (!state.form) {
          return Promise.resolve(false);
        }

        return new Promise((resolve) => {
          state.form.validate((valid) => {
            resolve(valid);
          });
        });
      };
    },
  },

  mutations: {
    form(state, payload) {
      state.form = payload;
    },
  },
};
